<!-- Phase 3 create-modal template: BUI-styled form content hosted inside the
     shared Dialog.vue wrapper (see LiveStreamsListView.vue). Deliberately
     compact — the old modal was oversized (Phase 4 ask). -->

<template>
  <div class="create-live-stream-form">
    <StatusBar
      :errorMessage="errorMessage"
      :isLoading="isLoading"
      loadingMessage="Saving..."
      :isSuccess="isSuccess"
      successMessage="Saved!"
    />
    <div class="field-content">
      <div class="d-flex field-row">
        <label for="clsf-name" class="basis-1/2 text-sm font-bold">Name &#9733;</label>
        <TextField id="clsf-name" name="name" v-model="values.name" class="basis-1/2" width="100%" />
      </div>
    </div>

    <!-- Stream binding options (shared with the Live Stream editor). -->
    <div class="clsf-section-title">Stream Binding</div>
    <BindingFields v-model="values.sideFeatureBindingOptions" />

    <!-- Players Filters -->
    <div class="clsf-section-title">Target Players Filters</div>
    <PlayersFilters v-model="values.filters" />

    <div class="form-buttons">
      <ButtonCustomized label="Cancel" @click="onCancel" ctaSecondary />
      <ButtonCustomized label="Create" cta @click="onSubmit" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import BindingFields from "@/views/LiveStreamEditorView/BindingFields.vue";
import TextField from "@/components/form-fields/TextField.vue";
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";
import PlayersFilters from "@/views/PlayerSubscriptionEditorView/PlayersFilters/PlayersFilters.vue";

import { useCreateLiveStreamFormHelpers } from "./composables/createLiveStreamFormHelpers";
import useNotifications from "@/components/Notifications/composables/notifications";

import router from '@/router';


const emit = defineEmits(['submit', 'cancel', 'success', 'fail'])
const notification = useNotifications();

const {
  values,
  submitForm,
  isLoading,
  isSuccess,
  errorMessage,
  newSubscriptionId,
} = useCreateLiveStreamFormHelpers();

async function onSubmit() {
  await submitForm();
  if(isSuccess.value === true) {
    notification.success('Live Stream created and start stream command sent successfully to players!');
    emit('success');
    router.push({name: 'live-stream-editor', params: {id: newSubscriptionId.value}});
  } else {    // on failure
    emit('fail');
  }
}

function onCancel() {
  emit('cancel');
}
</script>

<style lang="scss" scoped>
.create-live-stream-form {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: min(32rem, calc(100vw - 6rem));
  color: var(--bui-tbl-row-text, #2a2969);
}

.clsf-section-title {
  margin-top: 0.5rem;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--bui-tbl-detail-text, #5c5c66);
}

.field-content {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  :deep(.field label) {
    color: var(--bui-tbl-row-text, #2a2a30);
  }

  :deep(.field input[type='text']) {
    color: var(--bui-ter-input-text, #1a1a1e);
    background: var(--bui-ter-input-fill, rgba(0, 0, 0, 0.04));
    border-color: var(--bui-ter-input-border, rgba(0, 0, 0, 0.12));
    width: 100%;
  }
}

.field-row {
  align-items: center;

  label {
    color: var(--bui-tbl-row-text, #2a2a30);
  }
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}
</style>
